import NomeclatureFilters from "./NomeclatureFilters"
import ProducerDetail from "./ProducerDetail"
import SeriesDetail from "./SeriesDetail"

export const Economic = {
    Series: SeriesDetail,
    Producer: ProducerDetail,
    NomenclatureFilters: NomeclatureFilters,
}
